<div class="picker-container">
  <div class="color-indication-section">
    <div class="color-indicator"  [style.background]="updatedColor"></div>
  </div>
  <div class="color-picker-button">
    <button mat-icon-button (click)="showHideColorCard($event)" #palatteBtn>
      <mat-icon [class.mat-primary]="isCardOpen">color_lens</mat-icon>
    </button>
    @if (isCardOpen) {
      <div class="unfocus"></div>
    }
    @if (isCardOpen) {
      <mat-card class="color-card" #colorCard  (click)="$event.stopPropagation();">
        <div class="row">
          @for (indicator of grayscale; track indicator) {
            <div class="color-indicator" [style.background]="indicator" (click)="updateColor(indicator)"></div>
          }
        </div>
        <div class="row">
          @for (indicator of majorColors; track indicator) {
            <div class="color-indicator" [style.background]="indicator" (click)="updateColor(indicator)"></div>
          }
        </div>
        <div class="final-row">
          @for (colors of otherColors; track colors) {
            <div class="row">
              @for (indicator of colors; track indicator) {
                <div class="color-indicator" [style.background]="indicator" (click)="updateColor(indicator)"></div>
              }
            </div>
          }
        </div>
      </mat-card>
    }
  </div>
</div>